import { useSearchParams } from 'react-router-dom';
import { createBranchSetupPath } from '../onboarding/branchSetupState.js';
import { branchIsLive } from '../../shell/merchantPreLive.js';
import { currentMerchantScope } from '../../shell/merchantContext.js';
import { BRANCH_ID_STORAGE_KEY } from './catalog.js';

export function useBranchIdParam(): string | null {
  const [params] = useSearchParams();
  return (
    params.get('branchId') ??
    params.get('id') ??
    getStoredBranchId() ??
    currentMerchantScope().branchId
  );
}

export function getStoredBranchId(): string | null {
  if (typeof localStorage === 'undefined') return null;
  return localStorage.getItem(BRANCH_ID_STORAGE_KEY);
}

export function setStoredBranchId(branchId: string): void {
  if (typeof localStorage === 'undefined') return;
  localStorage.setItem(BRANCH_ID_STORAGE_KEY, branchId);
}

export function branchListPath(): string {
  return '/branch-list';
}

/** Post-live branch creation — no setup spine query param. */
export function operationalCreateBranchPath(): string {
  return '/create-branch';
}

/** Pre-live merchants stay on the WF-05 setup spine. */
export function resolveCreateBranchPath(
  branches: Array<{ status?: string | null }> | undefined,
): string {
  const preLive = !branches?.some((branch) => branchIsLive(branch.status));
  return preLive ? createBranchSetupPath() : operationalCreateBranchPath();
}

export function branchProfilePath(branchId: string): string {
  return `/branch-profile?branchId=${encodeURIComponent(branchId)}`;
}

export function openingHoursPath(branchId: string): string {
  return `/opening-hours?branchId=${encodeURIComponent(branchId)}`;
}

export function openingHoursClosuresPath(branchId: string): string {
  return `/opening-hours?branchId=${encodeURIComponent(branchId)}&closures=1`;
}

export function specialClosuresPath(branchId: string): string {
  return `/special-closures?branchId=${encodeURIComponent(branchId)}`;
}

export function serviceAreaPath(branchId: string): string {
  return `/service-area?branchId=${encodeURIComponent(branchId)}`;
}

export function deliveryBandsPath(branchId: string): string {
  return `/delivery-bands?branchId=${encodeURIComponent(branchId)}`;
}

export function vatRegistrationPath(): string {
  return '/vat-registration';
}

export function fulfilmentSettingsPath(branchId: string): string {
  return `/fulfilment-settings?branchId=${encodeURIComponent(branchId)}`;
}

export function capacitySettingsPath(branchId: string): string {
  return `/capacity-settings?branchId=${encodeURIComponent(branchId)}`;
}

export function branchStatusPath(branchId: string): string {
  return `/branch-status?branchId=${encodeURIComponent(branchId)}`;
}

export function substitutionPolicyPath(branchId: string): string {
  return `/substitution-policy?branchId=${encodeURIComponent(branchId)}`;
}

export function businessProfilePath(): string {
  return '/business-profile';
}
